import {
  BaseIcon
} from "./chunk-Z3LMOCJ7.mjs";

// src/icons/networks/NetworkSolana.tsx
import { forwardRef } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var NetworkSolana = forwardRef(
  ({ variant = "mono", ...props }, ref) => /* @__PURE__ */ jsx(BaseIcon, { ...props, ref, children: variant === "mono" ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M19.125 7.448a.7.7 0 0 1-.456.18H2.644c-.569 0-.856-.65-.462-1.03L4.814 4.06a.67.67 0 0 1 .455-.188h16.088c.574 0 .855.656.456 1.038zm0 12.506a.7.7 0 0 1-.456.175H2.644c-.569 0-.856-.645-.462-1.026l2.632-2.544a.66.66 0 0 1 .455-.181h16.088c.574 0 .855.65.456 1.031zm0-9.651a.7.7 0 0 0-.456-.175H2.644c-.569 0-.856.645-.462 1.025l2.632 2.545a.7.7 0 0 0 .455.18h16.088c.574 0 .855-.65.456-1.03z"
    }
  ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "url(#solana__a)",
        d: "M19.125 7.447a.7.7 0 0 1-.456.18H2.644c-.569 0-.856-.65-.462-1.03l2.632-2.538a.67.67 0 0 1 .455-.188h16.088c.574 0 .855.656.456 1.038z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "url(#solana__b)",
        d: "M19.125 19.954a.7.7 0 0 1-.456.175H2.644c-.569 0-.856-.645-.462-1.026l2.632-2.544a.66.66 0 0 1 .455-.181h16.088c.574 0 .855.65.456 1.03z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "url(#solana__c)",
        d: "M19.125 10.303a.7.7 0 0 0-.456-.175H2.644c-.569 0-.856.645-.462 1.025l2.632 2.545a.7.7 0 0 0 .455.18h16.088c.574 0 .855-.65.456-1.03z"
      }
    ),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "solana__a",
          x1: "2.001",
          x2: "22.51",
          y1: "59.823",
          y2: "59.635",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#599DB0" }),
            /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#47F8C3" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "solana__b",
          x1: "2.001",
          x2: "22.379",
          y1: "8.853",
          y2: "8.697",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#C44FE2" }),
            /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#73B0D0" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "solana__c",
          x1: "3.152",
          x2: "21.225",
          y1: "12.003",
          y2: "12.003",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#778CBF" }),
            /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#5DCDC9" })
          ]
        }
      )
    ] })
  ] }) })
);
NetworkSolana.displayName = "solana";
var NetworkSolana_default = NetworkSolana;

export {
  NetworkSolana_default
};
